"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Select_1 = __importDefault(require("@material-ui/core/Select"));

var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));

var utils_1 = __importDefault(require("@nexys/utils"));

var propValueToDefault = function propValueToDefault(name, data, options) {
  var v = utils_1.default.ds.get(name, data);

  if (v === null) {
    return '';
  }

  var a = options.find(function (x) {
    if (x.uuid) {
      return x.uuid === v.uuid;
    }

    return x.id === v.id;
  });

  if (a) {
    if (a.uuid) {
      return a.uuid;
    }

    return a.id;
  }

  return '';
};

function Select(props) {
  var id = props.id,
      name = props.name,
      data = props.data,
      promise = props.promise,
      disabled = props.disabled,
      rest = __rest(props, ["id", "name", "data", "promise", "disabled"]);

  var strName = name.toString();

  var _react_1$useState = react_1.useState(props.options || []),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      options = _react_1$useState2[0],
      setOptions = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(propValueToDefault(strName, data, options)),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      value = _react_1$useState4[0],
      setValue = _react_1$useState4[1];

  react_1.useEffect(function () {
    setValue(propValueToDefault(strName, data, options));
  }, [strName, data, options]);
  react_1.useEffect(function () {
    setOptions(props.options || []);
  }, [props.options]);

  if (promise) {
    promise.then(function (x) {
      setOptions(x);
      setValue(propValueToDefault(strName, data, options));
    });
  }

  var onChange = function onChange(event) {
    var newId = event.target.value;
    var newValue = options.filter(function (option) {
      return option.uuid ? option.uuid === newId : option.id === newId;
    })[0];
    props.onChange({
      name: props.name.toString(),
      value: newValue
    });
    setValue(newValue.uuid ? newValue.uuid : newValue.id);
  };

  return react_1.default.createElement(Select_1.default, Object.assign({
    id: id ? id : strName,
    name: strName
  }, rest, {
    onChange: onChange,
    value: value,
    fullWidth: true,
    disabled: disabled
  }), options.map(function (option, k) {
    return react_1.default.createElement(MenuItem_1.default, {
      key: k,
      value: option.uuid ? option.uuid : option.id
    }, option.name);
  }));
}

exports.default = Select;